import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import SydLabel from '../../../../commonDesign/SydLabel'
import SydInput from '../../../../commonDesign/SydInput'
import SydSelect from '../../../../commonDesign/SydSelect'

export const NodeColors = ({ node, onUpdateNode }) => {
  const backgroundColorOptions = useMemo(() => {
    const options = [
      { label: 'Custom Entry', value: 'style.backgroundColor' }
    ]

    if (node?.data?.entityProps?.color) {
      options.push({
        label: node.data?.entityProps?.color,
        description: `This color is pulled from the linked ${node.data?.entityProps?.type ?? 'entity'}`,
        value: 'entityProps.color'
      })
    }
    return options
  }, [node.data?.entityProps])

  const borderColorOptions = useMemo(() => {
    const options = [
      { label: 'Custom Entry', value: 'style.borderColor' }
    ]

    if (node?.data?.entityProps?.color) {
      options.push({
        label: node.data?.entityProps?.color,
        description: `This color is pulled from the linked ${node.data?.entityProps?.type ?? 'entity'}`,
        value: 'entityProps.color'
      })
    }
    return options
  }, [node.data?.entityProps])

  const textColorOptions = useMemo(() => {
    const options = [
      { label: 'Custom Entry', value: 'style.color' }
    ]

    if (node?.data?.entityProps?.color) {
      options.push({
        label: node.data?.entityProps?.color,
        description: `This color is pulled from the linked ${node.data?.entityProps?.type ?? 'entity'}`,
        value: 'entityProps.color'
      })
    }
    return options
  }, [node.data?.entityProps])

  return (
    <div className='flex flex-col gap-md'>
      <div>
        <p className='m-0 font-size-sm'>Background Color</p>
        <div className='flex gap-2 w-full'>
          <SydLabel label='Color Source' style={{ flex: 1 }}>
            <SydSelect
              size='sm'
              options={backgroundColorOptions}
              value={node.data?.displayOptions?.backgroundColor ?? 'style.backgroundColor'}
              onChange={(e) => onUpdateNode(['data', 'displayOptions', 'backgroundColor'], e.target.value)}
            />
          </SydLabel>
          {(!node.data?.displayOptions?.backgroundColor || node.data?.displayOptions?.backgroundColor === 'style.backgroundColor') && (
            <SydLabel label='Color'>
              <SydInput
                size='sm'
                type='color'
                onChange={(e) => onUpdateNode(['data', 'style', 'backgroundColor'], e.target.value)}
                value={node.data?.style?.backgroundColor ?? '#ffffff'}
                minWidth='100px'
              />
            </SydLabel>
          )}
        </div>
      </div>

      <div>
        <p className='m-0 font-size-sm'>Border Color</p>
        <div className='flex gap-2 w-full'>
          <SydLabel label='Color Source' style={{ flex: 1 }}>
            <SydSelect
              size='sm'
              options={borderColorOptions}
              value={node.data?.displayOptions?.borderColor ?? 'style.borderColor'}
              onChange={(e) => onUpdateNode(['data', 'displayOptions', 'borderColor'], e.target.value)}
            />
          </SydLabel>
          {(!node.data?.displayOptions?.borderColor || node.data?.displayOptions?.borderColor === 'style.borderColor') && (
            <SydLabel label='Color'>
              <SydInput
                size='sm'
                type='color'
                onChange={(e) => onUpdateNode(['data', 'style', 'borderColor'], e.target.value)}
                value={node.data?.style?.borderColor ?? '#ffffff'}
                minWidth='100px'
              />
            </SydLabel>
          )}
        </div>
      </div>

      <div>
        <p className='m-0 font-size-sm'>Text Color</p>
        <div className='flex gap-2 w-full'>
          <SydLabel label='Color Source' style={{ flex: 1 }}>
            <SydSelect
              size='sm'
              options={textColorOptions}
              value={node.data?.displayOptions?.textColor ?? 'style.color'}
              onChange={(e) => onUpdateNode(['data', 'displayOptions', 'textColor'], e.target.value)}
            />
          </SydLabel>
          {(!node.data?.displayOptions?.textColor || node.data?.displayOptions?.textColor === 'style.color') && (
            <SydLabel label='Color'>
              <SydInput
                size='sm'
                type='color'
                onChange={(e) => onUpdateNode(['data', 'style', 'color'], e.target.value)}
                value={node.data?.style?.color ?? '#000000'}
                minWidth='100px'
              />
            </SydLabel>
          )}
        </div>
      </div>
    </div>
  )
}
NodeColors.propTypes = {
  node: PropTypes.shape({
    type: PropTypes.string,
    data: PropTypes.shape({
      nodeProps: PropTypes.shape({
        size: PropTypes.string
      }),
      style: PropTypes.shape({
        backgroundColor: PropTypes.string,
        borderColor: PropTypes.string,
        color: PropTypes.string
      }),
      displayOptions: PropTypes.shape({
        textColor: PropTypes.string,
        backgroundColor: PropTypes.string,
        borderColor: PropTypes.string
      }),
      entityProps: PropTypes.shape({
        color: PropTypes.string,
        type: PropTypes.string
      })
    })
  }).isRequired,
  onUpdateNode: PropTypes.func.isRequired
}
